import Yup from "./validations"
export const NewsSchema = Yup.object().shape({
    title: Yup.string().required().max(255),
    description: Yup.string().min(100).required(),
    short_description: Yup.string().min(20).max(500).required(),
    image: Yup.string().required()
});